<script>

import PerPageSelect from "@/components/ui/PerPageSelect.vue";

export default {
    components: {PerPageSelect},
    data() {
        return {
            loading: true,
            firstLoading: true,
            enrollments: [],
            meta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            sort: {
                order: 'desc'
            },
            controller: null,
            perPage: parseInt(localStorage.getItem('perPage_enrollments') || '10'),
        }
    },
    methods: {
        loadData() {
            this.controller = new AbortController();
            this.loading = true;
            window.scrollTo({top: 0});
            this.enrollments = [];
            if (this.meta.current_page > 1) {
                window.scrollTo({top: 0});
            }
            axios.get('/training-enrollments', {
                signal: this.controller.signal,
                params: {
                    page: this.meta.current_page,
                    per_page: this.perPage,
                    order: this.sort.order
                }
            }).then(response => {
                this.enrollments = response.data.data;
                this.meta.current_page = response.data.meta.current_page;
                this.meta.total = response.data.meta.total;
                this.meta.per_page = response.data.meta.per_page;
            }).catch(() => {
            }).finally(() => {
                this.loading = false;
            })
        },
        onPageChange(page) {
            this.controller.abort();
            this.meta.current_page = page;
            this.loadData();
        },
        onSort(field, order) {
            this.controller.abort();
            this.sort = {field, order};
            this.loadData();
        },
        onPerPageChange() {
            localStorage.setItem('perPage_enrollments', String(this.perPage));
            this.meta.current_page = 1;
            this.loadData();
        },
    },
    mounted() {
        this.loadData();
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <div class="trainings-index">

        <b-table
            :data="loading ? [] : enrollments"
            :loading="loading"

            :paginated="!loading && enrollments.length"
            backend-pagination
            :total="loading ? 0 : meta.total"
            :per-page="perPage"
            @page-change="onPageChange"
            :aria-next-label="$t('navigation.next_page')"
            :aria-previous-label="$t('navigation.previous_page')"
            :aria-page-label="$t('navigation.page')"
            :aria-current-label="$t('navigation.current_page')"

            backend-sorting
            sort-icon="arrow-up"
            default-sort-direction="desc"
            :default-sort="['training_date', 'desc']"
            @sort="onSort">

            <b-table-column field="first_name" :label="$t('users.fields.first_name.name')" v-slot="props">
                {{ props.row.user.first_name }}
            </b-table-column>

            <b-table-column field="last_name" :label="$t('users.fields.last_name.name')" v-slot="props">
                {{ props.row.user.last_name }}
            </b-table-column>

            <b-table-column field="company.name" :label="$t('companies.fields.name.name')" v-slot="props">
                {{ props.row.user.company.name }}
            </b-table-column>

            <b-table-column field="training.name" :label="$t('trainings.fields.name.name')" v-slot="props">
                {{ props.row.training.name }}
            </b-table-column>

            <b-table-column field="training_date"
                            sortable
                            :label="$t('training_enrollments.fields.date.name')"
                            v-slot="props">
                {{ props.row.training_date }}
            </b-table-column>

            <b-table-column field="price" :label="$t('training_enrollments.fields.price.name')" v-slot="props">
                {{ props.row.price }}
            </b-table-column>

            <template #bottom-left>
                <PerPageSelect v-model="perPage" @change="onPerPageChange" />
            </template>

        </b-table>

        <loader :loading="loading"></loader>
    </div>
</template>
